import { defineStore } from 'pinia';

// Abre a tela de novidades de qualquer lugar (menu do perfil, versão em
// Configurações) sem passar eventos pela barra lateral.
export const useReleaseNotesStore = defineStore('releaseNotes', {
  state: () => ({
    isHistoryOpen: false,
  }),

  actions: {
    openHistory() {
      this.isHistoryOpen = true;
    },
    closeHistory() {
      this.isHistoryOpen = false;
    },
  },
});
